import { Image, StyleSheet } from 'react-native';

import { BonusGInfoBtn } from '../../../../assets';
import { TouchableOpacity } from '../../common/Touchable';
import { bonusGamesModalStyles } from './styles';

interface BGInfoButtonProps {
	isSmall: boolean;
	onPress?: () => void;
}

const BGInfoButton = ({ isSmall, onPress }: BGInfoButtonProps) => {
	return (
		<TouchableOpacity
			onPress={onPress}
			activeOpacity={0.7}
			style={{
				...bonusGamesModalStyles.buttons,
				top: isSmall ? -20 : -18,
				left: isSmall ? -2 : 20,
				width: isSmall ? 30 : 22,
				height: isSmall ? 30 : 22,
				transform: [{ scale: isSmall ? 1.4 : 1.4 }],
			}}
		>
			<Image source={BonusGInfoBtn} style={styles.iconFill} />
		</TouchableOpacity>
	);
};

const styles = StyleSheet.create({
	iconFill: {
		width: '100%',
		height: '100%',
	},
});

export default BGInfoButton;
